import React, { Fragment } from 'react';
import { HomeHelmet } from '../components/MoiPayHelmet';
import HomeHeroSection from '../components/home_v2/Home';


export default function HomeScreen() {
    return (
        <Fragment>
            <HomeHelmet />
            <HomeHeroSection />
        </Fragment>
    );
}
